import { Instagram, Facebook, MessageCircle } from "lucide-react";
import { CONTACT } from "@/lib/site";

const QUICK_NAV = [
  { label: "Tours & Packages", href: "#packages" },
  { label: "Ticketing & Visas", href: "#services" },
  { label: "Why Parth Travels", href: "#why-parth" },
  { label: "Photo Highlights", href: "#gallery" },
  { label: "Contact & Enquiry", href: "#contact" },
];

const SERVICE_LIST = [
  "Air, Bus & Railway Booking",
  "Tourist & Business Visa Stamping",
  "Domestic Vacation Circuits",
  "International Group Departures",
  "Corporate & Executive Offsites",
];

const SOCIALS = [
  { label: "Instagram", href: CONTACT.instagramHref, icon: Instagram, testid: "social-instagram", cls: "bg-gradient-to-tr from-amber-500 via-rose-500 to-fuchsia-600 hover:from-amber-600 hover:via-rose-600 hover:to-fuchsia-700 border-transparent" },
  { label: "WhatsApp", href: CONTACT.whatsappHref, icon: MessageCircle, testid: "social-whatsapp", cls: "bg-emerald-600 hover:bg-emerald-500 border-transparent" },
  { label: "Facebook", href: CONTACT.facebookHref, icon: Facebook, testid: "social-facebook", cls: "bg-sky-700 hover:bg-sky-600 border-transparent" },
];

export const Footer = () => (
  <footer className="bg-stone-900 text-stone-400 text-xs border-t border-stone-800 py-12" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-10">
        <div className="space-y-3">
          <span className="text-base font-bold text-white block">Parth Travels</span>
          <p className="text-stone-400 text-xs leading-relaxed">
            Your one-stop travel solutions provider offering flight, bus &amp; rail ticketing, passport-visa processing, and domestic &amp; global tour packages.
          </p>
        </div>

        <div>
          <span className="text-xs font-bold text-white uppercase tracking-wider block mb-3">Quick Navigation</span>
          <ul className="space-y-2">
            {QUICK_NAV.map((n) => (
              <li key={n.href}>
                <a href={n.href} className="hover:text-amber-400 transition-colors">{n.label}</a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <span className="text-xs font-bold text-white uppercase tracking-wider block mb-3">Services</span>
          <ul className="space-y-2 text-stone-400">
            {SERVICE_LIST.map((s) => (
              <li key={s}>{s}</li>
            ))}
          </ul>
        </div>

        <div>
          <span className="text-xs font-bold text-white uppercase tracking-wider block mb-3">Connect Socially</span>
          <p className="text-stone-400 text-xs mb-3">Follow our latest travel deals, tour schedules, and customer memories.</p>
          <div className="flex items-center space-x-3">
            {SOCIALS.map((s) => (
              <a
                key={s.label}
                href={s.href}
                target={s.href.startsWith("http") ? "_blank" : undefined}
                rel={s.href.startsWith("http") ? "noopener noreferrer" : undefined}
                data-testid={s.testid}
                aria-label={s.label}
                className={`w-9 h-9 rounded-full text-white flex items-center justify-center shadow-sm transition-transform hover:-translate-y-0.5 border ${s.cls}`}
              >
                <s.icon className="w-4 h-4" aria-hidden="true" />
              </a>
            ))}
          </div>
        </div>
      </div>

      <div className="pt-8 border-t border-stone-800 flex flex-col sm:flex-row items-center justify-between text-[11px] text-stone-700">
        <span>&copy; Parth Travels · Complete Travel Solutions</span>
        <span className="mt-2 sm:mt-0">Serving travellers across India &amp; Worldwide</span>
      </div>
    </div>
  </footer>
);
